import React from 'react';
import { Paper, Typography, Grid, Box, Divider, Alert } from '@mui/material';

const InfoField: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <Box mb={1}>
        <Typography variant="subtitle1" fontWeight={600}>
            {label}
        </Typography>
        <Typography variant="body1">
            {value === null || value === undefined || value === '' ? 'Não informado' : value}
        </Typography>
    </Box>
);

interface Step1SimViewProps {
    data: {
        referenceYear: number;
        hasSim: boolean | null;
        simActive: boolean | null;
        simEstablishments: number | '';
        hasVet: boolean | null;
        joinedSusaf: boolean | null;
        wantsSusaf: boolean | null;
    };
}

const booleanText = (value: boolean | null) =>
    value === true ? 'Sim' : value === false ? 'Não' : 'Não informado';

const Step1SimView: React.FC<Step1SimViewProps> = ({ data }) => (
    <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
            SIM (Serviço de Inspeção Municipal)
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <InfoField
            label="Ano de referência do Questionário"
            value={data.referenceYear}
        />

        <Grid container spacing={2}>
            <Grid item xs={12}>
                <InfoField
                    label="O município possui Serviço de Inspeção Municipal (SIM) implantado?"
                    value={booleanText(data.hasSim)}
                />
            </Grid>

            {data.hasSim && (
                <>
                    <Grid item xs={12}>
                        <InfoField
                            label="O Serviço de Inspeção Municipal (SIM) está ativo (em funcionamento)?"
                            value={booleanText(data.simActive)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InfoField
                            label="Quantos empreendimentos/estabelecimentos possuem SIM no município?"
                            value={
                                data.simEstablishments === '' || data.simEstablishments === null || data.simEstablishments === undefined
                                    ? 'Não informado'
                                    : data.simEstablishments
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InfoField
                            label="O município possui médico veterinário exclusivo disponível para atender o SIM?"
                            value={booleanText(data.hasVet)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InfoField
                            label="O município fez adesão ao Sistema Unificado Estadual de Sanidade Agroindustrial Familiar e de Pequeno Porte - SUSAF/MT?"
                            value={booleanText(data.joinedSusaf)}
                        />
                        <Alert severity="info" sx={{ mt: 2 }}>
                            <strong>Nota explicativa:</strong> Para informações sobre o SUSAF/MT, vide Lei estadual nº 10.502, de 18/01/2017, e Decreto nº 218, de 21/08/2019. Para mais informações{' '}
                            <a href="http://www.agriculturafamiliar.mt.gov.br/susaf2" target="_blank" rel="noopener noreferrer">
                                “SUSAF”
                            </a>.
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                        <InfoField
                            label="O município tem interesse em aderir ao SUSAF/MT?"
                            value={booleanText(data.wantsSusaf)}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    </Paper>
);

export default Step1SimView;